import { LoadingState } from '../ui';
// src/components/ProfileCheck.jsx

import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";
import ProfileForm from "./ProfileForm";

export default function ProfileCheck({ children, session }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showProfileForm, setShowProfileForm] = useState(false);

  useEffect(() => {
    const checkProfile = async () => {
      if (!session?.user?.id) {
        setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from("profiles")
        .select("username, date_of_birth")
        .eq("id", session.user.id)
        .single();

      if (error && error.code === "PGRST116") {
        // No profile found
        setShowProfileForm(true);
      } else if (data && !data.username) {
        // Profile exists but incomplete
        setShowProfileForm(true);
      } else if (data && data.username) {
        // Profile complete
        setProfile(data);
      }

      setLoading(false);
    };

    checkProfile();
  }, [session?.user?.id]);

  const handleProfileComplete = async () => {
    setShowProfileForm(false);
    
    // Refetch profile data
    if (!session?.user?.id) return;

    const { data, error } = await supabase
      .from("profiles")
      .select("username, date_of_birth")
      .eq("id", session.user.id)
      .single();

    if (data && data.username) {
      setProfile(data);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-surface-canvas flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#284239] mx-auto mb-4"></div>
          <LoadingState label="Loading..." />
        </div>
      </div>
    );
  }

  if (showProfileForm) {
    return <ProfileForm onComplete={handleProfileComplete} />;
  }

  return children;
}